import React from "react";

import { Title, Subtitle, Close } from "./styles";
import { ModalActionsPropsInterface } from "./interfaces"

//Assets
import close from "../../assets/icons/close.svg";

const ModalActions = (props: ModalActionsPropsInterface) => {
    return (        
        <div className="modal fade" id={props.id}  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-actions">
                <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between">
                        <div>
                            <Title style={{fontSize: props.titleSize ? props.titleSize : 39}}>{props.title}</Title>
                            <Subtitle>{props.subtitle}</Subtitle>
                        </div>
                        <Close data-dismiss="modal" aria-label="Close">
                            <img src={close} alt="fechar"/>
                        </Close>
                    </div>
                    <div className="modal-body">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalActions;